var showAllBtns = document.querySelectorAll('.show-all-btn');
var websitesListBlock = document.querySelector('.op-websites-list-wrapper'); // Check if websitesListBlock is not null before accessing its parentNode

if (websitesListBlock && websitesListBlock.parentNode) {
  websitesListBlock.parentNode.classList.add('row'); // Check if the parent node's parent node is not null before accessing it

  if (websitesListBlock.parentNode.parentNode) {
    websitesListBlock.parentNode.parentNode.classList.remove('is-layout-constrained');
  }
}

showAllBtns.forEach(function (btn) {
  btn.addEventListener('click', function () {
    var list = this.previousElementSibling; // Get the previous sibling (ul) of the clicked button.

    if (list) {
      list.classList.toggle('active'); // Add 'active' class to the ul.
    }

    this.classList.toggle('collapsed'); // Remove the 'collapsed' class from the clicked button.
  });
});